export enum MigrationItemSuggestionStatus {
  Unchecked = 'Unchecked',
  Ignored = 'Ignored',
  Matched = 'Matched',
  Checked = 'Checked',
}

export const MigrationItemSuggestionStatuses = Object.values(
  MigrationItemSuggestionStatus
);
